"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllProperties = exports.isObject = exports.isIterable = exports.clone = void 0;
/**
 * Clones an object and it's properties (works for nested properties).
 * @param instance Object to clone
 */
function clone(instance) {
    var copy = new instance.constructor();
    Object.assign(copy, instance);
    return copy;
}
exports.clone = clone;
/**
 * Return true if object is iterable. EG Array, Set, Map
 * @param obj Object to check agains iterableness
 * @param excludeString Strings are also iterables, exclude them by default.
 */
function isIterable(obj, excludeString) {
    if (excludeString === void 0) { excludeString = true; }
    // check for null and undefined
    if (obj == null || (excludeString && typeof obj === 'string')) {
        return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
}
exports.isIterable = isIterable;
/**
 * Simple check for isObject (using JS's Object)
 * @param obj obj to check
 */
function isObject(obj) {
    return !!obj && obj.constructor === Object;
}
exports.isObject = isObject;
/**
 * Returns set with all the properties (getters) for a given model
 * @param model Class to get props form
 */
function getAllProperties(model) {
    var e_1, _a;
    var properties = new Set();
    for (var o = model; o !== Object.prototype; o = Object.getPrototypeOf(o)) {
        try {
            for (var _b = (e_1 = void 0, __values(Object.getOwnPropertyNames(o))), _c = _b.next(); !_c.done; _c = _b.next()) {
                var name_1 = _c.value;
                var descriptor = Object.getOwnPropertyDescriptor(o, name_1);
                if (typeof descriptor.get === 'function') {
                    properties.add(name_1);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return properties;
}
exports.getAllProperties = getAllProperties;
//# sourceMappingURL=object.js.map